export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      agency: "Agence",
      services: "Services",
      players: "Joueurs",
      contact: "Contact",
      cta: "Nous contacter",
    },
    hero: {
      eyebrow: "Agent de joueurs licencié FIFA",
      titleLines: ["HM Sport", "Consulting"],
      subtitle:
        "L'excellence au service des footballeurs. Nous accompagnons chaque talent, sur le terrain comme en dehors.",
      discover: "Découvrir",
    },
    marquee: ["Agence de joueurs", "Licence FIFA", "Gestion de carrière"],
    about: {
      label: "À propos",
      name: "Hugues MVOULE",
      role: "Fondateur & Agent de Joueurs Licencié FIFA",
      intro: [
        "Le football est bien plus qu'un métier. C'est une vocation, un engagement et une responsabilité envers ceux qui rêvent d'atteindre le plus haut niveau.",
        "Ancien footballeur international Gabonais, Hugues MVOULE a connu les exigences du football professionnel, les défis d'une carrière de joueur et les décisions qui peuvent transformer un parcours. Cette expérience de terrain lui permet aujourd'hui d'accompagner chaque joueur avec une compréhension authentique de ses ambitions, de ses difficultés et de son potentiel.",
        "Animé par la passion de transmettre et de faire grandir les talents, il fonde HM Sport Consulting avec une vision claire : offrir à chaque joueur un accompagnement d'excellence, fondé sur la confiance, l'intégrité et une stratégie de carrière durable.",
      ],
      visionTitle: "Une vision différente de l'accompagnement",
      visionLead:
        "Chez HM Sport Consulting, un joueur n'est jamais considéré comme un simple dossier ou un numéro.",
      visionPoints: [
        "Chaque carrière est unique.",
        "Chaque décision est réfléchie.",
        "Chaque opportunité est sélectionnée dans l'intérêt du joueur.",
      ],
      visionBody: [
        "Notre priorité est de construire des carrières solides, durables et cohérentes, en privilégiant avant tout le projet sportif et humain.",
        "Nous croyons que le véritable succès ne se mesure pas uniquement par un contrat signé, mais par la capacité d'un joueur à évoluer dans le bon environnement, au bon moment, avec les bonnes personnes.",
      ],
      valuesTitle: "Des valeurs qui font la différence",
      values: [
        {
          title: "Rigueur",
          text: "Chaque dossier est étudié avec exigence. Chaque détail compte. Les négociations, les opportunités et les choix de carrière sont préparés avec méthode afin d'offrir les meilleures perspectives à nos joueurs.",
        },
        {
          title: "Transparence",
          text: "Une relation de confiance ne peut exister sans une communication honnête. Chez HM Sport Consulting, nous privilégions la clarté, l'écoute et la sincérité dans chacune de nos décisions.",
        },
        {
          title: "Professionnalisme",
          text: "En tant qu'Agent de Joueurs Licencié FIFA, Hugues MVOULE accompagne ses joueurs dans le respect des plus hauts standards de la profession, avec une approche moderne, structurée et conforme à la réglementation internationale.",
        },
        {
          title: "Proximité",
          text: "Chaque joueur bénéficie d'un accompagnement personnalisé. Être disponible, comprendre les attentes des familles et rester présent à chaque étape du parcours fait partie intégrante de notre philosophie.",
        },
      ],
      networkTitle: "Un réseau au service de votre avenir",
      networkBody: [
        "Grâce à un réseau international développé au fil des années avec des clubs professionnels, académies, recruteurs et décideurs du football en Europe et à travers le monde, HM Sport Consulting met en relation les joueurs avec des projets sportifs correspondant réellement à leur profil.",
        "Notre objectif n'est pas de multiplier les propositions. Notre objectif est de trouver la bonne opportunité, au bon moment, pour permettre à chaque joueur de poursuivre sa progression dans les meilleures conditions.",
      ],
      closingTitle: "Votre carrière mérite une vision.",
      closingBody: [
        "Choisir HM Sport Consulting, c'est choisir un partenaire qui place votre réussite au cœur de chacune de ses décisions.",
        "Que vous soyez un jeune talent en pleine progression ou un joueur confirmé à la recherche d'un nouveau défi, notre engagement reste le même : vous accompagner avec exigence, défendre vos intérêts avec intégrité et construire votre avenir avec ambition.",
      ],
      tagline: [
        "Connecter les talents.",
        "Créer les opportunités.",
        "Construire les carrières.",
      ],
      trustTitle: "Pourquoi les joueurs nous font confiance ?",
      trust: [
        "Agent de Joueurs Licencié FIFA",
        "Ancien International Gabonais",
        "Accompagnement personnalisé du joueur et de sa famille",
        "Réseau international de contacts dans le football professionnel",
        "Respect strict de l'éthique et des règlements FIFA",
        "Vision de carrière à long terme",
        "Disponibilité, transparence et proximité",
      ],
    },
    stats: [
      "Licencié FIFA",
      "Disponibilité",
      "Domaines d'expertise",
      "Interlocuteur dédié",
    ],
    services: {
      label: "Nos services",
      titleLines: ["Un accompagnement", "à 360°"],
      subtitle:
        "De la signature du contrat à la gestion de l'image, nous couvrons chaque dimension de la carrière d'un footballeur professionnel.",
      hint: "Cliquez sur un service pour découvrir le détail.",
      items: [
        {
          title: "Négociation de contrats",
          text: "Défense de vos intérêts lors des transferts, renouvellements et clauses contractuelles.",
          details: [
            "Analyse et valorisation de votre profil sur le marché des transferts.",
            "Négociation des transferts, prolongations et clauses (primes, bonus, droits à l'image).",
            "Sécurisation des meilleures conditions financières et sportives.",
            "Relation directe avec les directions sportives, présidents et clubs.",
          ],
        },
        {
          title: "Gestion de carrière",
          text: "Stratégie sportive globale : choix de clubs, projet de jeu et planification à long terme.",
          details: [
            "Définition d'un projet sportif clair, ambitieux et progressif.",
            "Choix des clubs et environnements adaptés à votre développement.",
            "Planification à court, moyen et long terme de votre carrière.",
            "Accompagnement dans les moments clés : transitions, blessures, rebonds.",
          ],
        },
        {
          title: "Image & sponsoring",
          text: "Développement de la marque personnelle, partenariats et présence médiatique.",
          details: [
            "Construction et développement de votre marque personnelle.",
            "Négociation de partenariats et de contrats d'équipementiers.",
            "Stratégie de communication et présence sur les réseaux sociaux.",
            "Relations médias et gestion de votre réputation.",
          ],
        },
        {
          title: "Conseil juridique & fiscal",
          text: "Accompagnement sur les aspects juridiques, fiscaux et patrimoniaux de votre carrière.",
          details: [
            "Sécurisation juridique de l'ensemble de vos contrats.",
            "Optimisation fiscale et gestion de votre patrimoine.",
            "Accompagnement lors des mobilités et transferts internationaux.",
            "Réseau d'avocats et d'experts spécialisés partenaires.",
          ],
        },
        {
          title: "Développement sportif",
          text: "Suivi de la performance, préparation et mise en relation avec les meilleurs experts.",
          details: [
            "Suivi de la performance et de la préparation physique.",
            "Mise en relation avec préparateurs, nutritionnistes et coachs.",
            "Analyse vidéo et data pour accélérer votre progression.",
            "Encadrement des jeunes talents et lien avec les centres de formation.",
          ],
        },
      ],
    },
    roster: {
      label: "Portefeuille",
      titleLines: ["Nos", "talents"],
      subtitle:
        "Notre portefeuille est organisé par catégorie. Chaque profil sera présenté avec sa photo, son club et son parcours.",
      categories: [
        "Joueurs professionnels",
        "Espoirs / Centre de formation",
        "Entraîneurs / Coachs",
      ],
      filters: ["Tous", "Gardiens", "Défenseurs", "Milieux", "Attaquants", "Coachs"],
      emptyPosition: "Poste à venir",
      emptyName: "Bientôt dévoilé",
      soon: "Bientôt",
      cta: "Rejoindre l'agence",
    },
    contact: {
      label: "Contact",
      titleLines: ["Parlons", "de votre", "avenir"],
      emailLabel: "Email",
      instagramLabel: "Instagram",
      name: "Nom *",
      email: "Email *",
      subject: "Sujet",
      message: "Votre message *",
      submit: "Envoyer le message",
      sending: "Envoi...",
      toastFill: "Merci de remplir les champs obligatoires.",
      toastSuccess: "Message envoyé. Nous vous recontacterons rapidement.",
      toastError: "Une erreur est survenue. Réessayez plus tard.",
    },
    qr: {
      label: "Restons connectés",
      titleLines: ["Scannez", "& suivez-nous"],
      subtitle:
        "Accédez instantanément à notre page Instagram et à notre site en scannant ces QR codes, ou téléchargez-les pour vos supports.",
      instagram: "Instagram",
      site: "Site internet",
      download: "Télécharger",
    },
    footer: {
      marquee: "Agent de joueurs licencié FIFA",
      navTitle: "Navigation",
      contactTitle: "Contact",
      emailLabel: "Email",
      rights: "Tous droits réservés.",
      tagline: "Agent de joueurs licencié FIFA",
    },
  },

  en: {
    nav: {
      home: "Home",
      agency: "Agency",
      services: "Services",
      players: "Players",
      contact: "Contact",
      cta: "Contact us",
    },
    hero: {
      eyebrow: "FIFA Licensed Football Agent",
      titleLines: ["HM Sport", "Consulting"],
      subtitle:
        "Excellence at the service of footballers. We support every talent, on and off the pitch.",
      discover: "Discover",
    },
    marquee: ["Football agency", "FIFA License", "Career management"],
    about: {
      label: "About",
      name: "Hugues MVOULE",
      role: "Founder & FIFA Licensed Football Agent",
      intro: [
        "Football is far more than a job. It is a calling, a commitment and a responsibility towards those who dream of reaching the highest level.",
        "A former Gabonese international footballer, Hugues MVOULE has experienced the demands of professional football, the challenges of a playing career and the decisions that can transform a journey. This first-hand experience allows him today to support each player with a genuine understanding of their ambitions, their difficulties and their potential.",
        "Driven by a passion for passing on knowledge and helping talents grow, he founded HM Sport Consulting with a clear vision: to offer every player world-class support, built on trust, integrity and a sustainable career strategy.",
      ],
      visionTitle: "A different vision of representation",
      visionLead:
        "At HM Sport Consulting, a player is never seen as a simple file or a number.",
      visionPoints: [
        "Every career is unique.",
        "Every decision is carefully considered.",
        "Every opportunity is selected in the player's interest.",
      ],
      visionBody: [
        "Our priority is to build solid, sustainable and coherent careers, prioritising above all the sporting and human project.",
        "We believe that true success is not measured solely by a signed contract, but by a player's ability to develop in the right environment, at the right time, with the right people.",
      ],
      valuesTitle: "Values that make the difference",
      values: [
        {
          title: "Rigour",
          text: "Every case is studied with the highest standards. Every detail counts. Negotiations, opportunities and career choices are prepared methodically to offer the best prospects to our players.",
        },
        {
          title: "Transparency",
          text: "A relationship of trust cannot exist without honest communication. At HM Sport Consulting, we prioritise clarity, listening and sincerity in every decision.",
        },
        {
          title: "Professionalism",
          text: "As a FIFA Licensed Football Agent, Hugues MVOULE supports his players in line with the highest standards of the profession, with a modern, structured approach compliant with international regulations.",
        },
        {
          title: "Closeness",
          text: "Every player benefits from personalised support. Being available, understanding families' expectations and staying present at every stage of the journey is an integral part of our philosophy.",
        },
      ],
      networkTitle: "A network at the service of your future",
      networkBody: [
        "Thanks to an international network built over the years with professional clubs, academies, scouts and football decision-makers across Europe and around the world, HM Sport Consulting connects players with sporting projects that truly match their profile.",
        "Our goal is not to multiply offers. Our goal is to find the right opportunity, at the right time, to allow each player to continue their progression in the best possible conditions.",
      ],
      closingTitle: "Your career deserves a vision.",
      closingBody: [
        "Choosing HM Sport Consulting means choosing a partner who places your success at the heart of every decision.",
        "Whether you are a young talent on the rise or an established player looking for a new challenge, our commitment remains the same: to support you with rigour, defend your interests with integrity and build your future with ambition.",
      ],
      tagline: [
        "Connecting talents.",
        "Creating opportunities.",
        "Building careers.",
      ],
      trustTitle: "Why do players trust us?",
      trust: [
        "FIFA Licensed Football Agent",
        "Former Gabonese International",
        "Personalised support for the player and their family",
        "International network of contacts in professional football",
        "Strict respect for ethics and FIFA regulations",
        "Long-term career vision",
        "Availability, transparency and closeness",
      ],
    },
    stats: [
      "FIFA Licensed",
      "Availability",
      "Areas of expertise",
      "Dedicated contact",
    ],
    services: {
      label: "Our services",
      titleLines: ["End-to-end", "support"],
      subtitle:
        "From signing the contract to managing your image, we cover every dimension of a professional footballer's career.",
      hint: "Click a service to discover the details.",
      items: [
        {
          title: "Contract negotiation",
          text: "Defending your interests during transfers, renewals and contractual clauses.",
          details: [
            "Analysis and valuation of your profile on the transfer market.",
            "Negotiation of transfers, extensions and clauses (bonuses, image rights).",
            "Securing the best financial and sporting conditions.",
            "Direct relationships with sporting directors, presidents and clubs.",
          ],
        },
        {
          title: "Career management",
          text: "Overall sporting strategy: club choices, playing project and long-term planning.",
          details: [
            "Defining a clear, ambitious and progressive sporting project.",
            "Choosing clubs and environments suited to your development.",
            "Short, medium and long-term planning of your career.",
            "Support in key moments: transitions, injuries, comebacks.",
          ],
        },
        {
          title: "Image & sponsorship",
          text: "Personal brand development, partnerships and media presence.",
          details: [
            "Building and developing your personal brand.",
            "Negotiating partnerships and kit-supplier contracts.",
            "Communication strategy and social media presence.",
            "Media relations and reputation management.",
          ],
        },
        {
          title: "Legal & tax advice",
          text: "Support on the legal, tax and wealth aspects of your career.",
          details: [
            "Legal protection of all your contracts.",
            "Tax optimisation and wealth management.",
            "Support during international moves and transfers.",
            "A network of specialised partner lawyers and experts.",
          ],
        },
        {
          title: "Athletic development",
          text: "Performance monitoring, preparation and connections with the best experts.",
          details: [
            "Monitoring of performance and physical preparation.",
            "Connections with fitness coaches, nutritionists and trainers.",
            "Video and data analysis to speed up your progress.",
            "Guidance for young talents and links with academies.",
          ],
        },
      ],
    },
    roster: {
      label: "Portfolio",
      titleLines: ["Our", "talents"],
      subtitle:
        "Our portfolio is organised by category. Each profile will be presented with their photo, club and background.",
      categories: [
        "Professional players",
        "Prospects / Academy",
        "Managers / Coaches",
      ],
      filters: ["All", "Goalkeepers", "Defenders", "Midfielders", "Forwards", "Coaches"],
      emptyPosition: "Position coming soon",
      emptyName: "To be revealed",
      soon: "Soon",
      cta: "Join the agency",
    },
    contact: {
      label: "Contact",
      titleLines: ["Let's talk", "about your", "future"],
      emailLabel: "Email",
      instagramLabel: "Instagram",
      name: "Name *",
      email: "Email *",
      subject: "Subject",
      message: "Your message *",
      submit: "Send message",
      sending: "Sending...",
      toastFill: "Please fill in the required fields.",
      toastSuccess: "Message sent. We'll get back to you shortly.",
      toastError: "An error occurred. Please try again later.",
    },
    qr: {
      label: "Stay connected",
      titleLines: ["Scan", "& follow us"],
      subtitle:
        "Instantly access our Instagram page and website by scanning these QR codes, or download them for your materials.",
      instagram: "Instagram",
      site: "Website",
      download: "Download",
    },
    footer: {
      marquee: "FIFA Licensed Football Agent",
      navTitle: "Navigation",
      contactTitle: "Contact",
      emailLabel: "Email",
      rights: "All rights reserved.",
      tagline: "FIFA Licensed Football Agent",
    },
  },
};
